import React from 'react';
import { Drawer, Card, Table, Tag } from 'antd';

const SubmissionErrorsDrawer = (props) => {
  const { visible, onClose, record } = props;
  const errorsArray = (record && record.errorDetails && Array.isArray(record.errorDetails))
    ? record.errorDetails
    : [];

  const columns = [
    {
      title: 'No.',
      key: 'index',
      width: 60,
      render: (text, record, index) => index + 1
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 100,
      render: (text) => (
        <Tag>{text ? text.toUpperCase() : 'ERROR'}</Tag>
      )
    },
    {
      title: 'Error Message',
      dataIndex: 'message',
      key: 'message',
    },
    {
      title: 'Error Detail',
      dataIndex: 'name',
      key: 'name',
    }

  ];

  return (
    <Drawer
      title={`Submission Errors | ${record && record.correspondingAuthor ? record.correspondingAuthor : 'Unknown Author'} ${record && record.serialNo ? '(#' + record.serialNo + ')' : ''}`}
      width={700}
      visible={visible}
      placement="right"
      onClose={onClose}
    >
      <Card bordered={false}>
        <Table
          dataSource={errorsArray}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
          size="small"
          bordered
        />
      </Card>
    </Drawer>
  );
};

export default SubmissionErrorsDrawer;